// extracted by mini-css-extract-plugin
export var modalFooter = "_pi-0";